<template>
  <div style="width: 100%" @click="handleClick">
    <el-tooltip
      placement="top"
      effect="light"
      :content="customValue + ''"
      :disabled="tipDisbaled"
    >
      <el-input
        ref="input"
        v-model="customValue"
        v-bind="props"
        :disabled="disabled"
        :type="type === 'textarea' ? type : 'text'"
        @change="handleChange"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
      >
        <template #suffix>
          <slot name="suffix"></slot>
        </template>
        <template #prefix>
          <slot name="prefix"></slot>
        </template>
        <template #prepend>
          <slot name="prepend"></slot>
        </template>
        <template #append>
          <slot name="append"></slot>
        </template>
        <template #default>
          <slot name="default"></slot>
        </template>
      </el-input>
    </el-tooltip>
  </div>
</template>

<script>
import { Decimal } from 'decimal.js'

export default {
  name: 'HxInput',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: [String, Number],
    default: [String, Number],
    disabled: Boolean,
    max: Number,
    min: Number,
    nonzero: Boolean,
    format: Function,
    radix: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      defaultProps: {
        clearable: true,
        size: 'small',
        placeholder: '请输入',
        maxlength: 200,
      },
      tipDisbaled: true,
    }
  },
  computed: {
    props() {
      return Object.assign({}, this.defaultProps, this.$attrs)
    },

    customValue: {
      get() {
        const disabled =
          (this.$refs.input && this.$refs.input.inputDisabled) || this.disabled

        if (disabled && this.format) {
          return this.format(this.value)
        }

        return this.value
      },
      set(val) {
        let m = ''
        if (this.type === 'number') {
          if (val === ' ') {
            return
          }

          val = ('' + val).trim()

          if (val.slice(0, 1) === '-') {
            m = '-'
            val = val.slice(1, val.length)
          }

          if ('min' in this && this.min === 0) {
            m = ''
          }

          const radix = this.radix || 5
          const reg = new RegExp(`^[0-9]+.{0,1}[0-9]{0,${radix}}$`)
          if (val !== '' && (!reg.test(val) || isNaN(val))) {
            return
          }

          if ((this.max || this.max === 0) && +(m + val) > this.max) {
            val = this.max
          }

          if ('min' in this && +(m + val) < this.min) {
            val = this.min
          }
        }

        val = ('' + val).indexOf('-') === -1 ? m + val : val

        this.$emit('input', val)
      },
    },
  },
  updated() {
    if (this.$refs.input.inputDisabled) {
      this.defaultProps.placeholder = ''
    } else {
      this.defaultProps.placeholder = '请输入'
    }

    const input = this.$refs.input.getInput()
    if (input.offsetWidth < input.scrollWidth) {
      this.tipDisbaled = false
    } else {
      this.tipDisbaled = true
    }
  },
  mounted() {
    if (this.$refs.input.inputDisabled) {
      this.defaultProps.placeholder = ''
    } else {
      this.defaultProps.placeholder = '请输入'
    }

    const input = this.$refs.input.getInput()
    if (input.offsetWidth < input.scrollWidth) {
      this.tipDisbaled = false
    } else {
      this.tipDisbaled = true
    }
  },
  methods: {
    handleChange(val) {
      if (!val.trim() && 'default' in this) {
        this.$emit('input', this.default)
      }

      if (this.type === 'number' && val) {
        this.$emit('input', val)
      }

      if (this.type === 'number' && this.nonzero && +val === 0) {
        this.$emit('input', '')
      }

      if (this.type === 'number' && val && val[val.length - 1] === '.') {
        this.$emit('input', +String(val).slice(0, -1))
      }

      if (this.type === 'number' && val && val === '-') {
        this.$emit('input', '')
      }

      if (this.type === 'text') {
        this.$emit('input', val.trim())
      }

      this.$emit('change', val)
    },
    handleClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>
